document.addEventListener("DOMContentLoaded", function () {
      Fancybox.bind("[data-fancybox='gallery']", {});
  });
  /*
  $(document).ready(function(){
      $('.cart-recommendations-slider').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 2000,
          arrows: true,
          dots: true
      });
  });
  */
window._autofillcallbackhandler = window._autofillcallbackhandler || function() {};

/* Percentage Stats Animation */
document.addEventListener('DOMContentLoaded', function() {
  const percentGrid = document.querySelector('.percent_grid');
  if (!percentGrid) return;

  const percentElements = percentGrid.querySelectorAll('.rid-24');
  const targetValues = [93, 76, 85, 94];
  let hasAnimated = false;

  // Detect mobile for ring size
  const isMobile = window.innerWidth <= 767;
  const innerRadius = isMobile ? 27 : 40;

  // Intersection Observer to trigger animation when in view
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !hasAnimated) {
        hasAnimated = true;

        // Animate each percentage counter and ring
        percentElements.forEach((el, index) => {
          const target = targetValues[index];
          animateRing(el, target, innerRadius);
        });
      }
    });
  }, { threshold: 0.3 });

  observer.observe(percentGrid);

  function animateRing(element, target, radius) {
    const duration = 1500;
    const startTime = performance.now();

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Ease out cubic
      const easeOut = 1 - Math.pow(1 - progress, 3);
      const currentValue = Math.round(target * easeOut);

      // Update counter text
      element.textContent = currentValue + '%';

      // Update ring background with !important to override CSS
      element.style.setProperty('background',
        `radial-gradient(circle, #1a1a1a ${radius}px, transparent ${radius}px), conic-gradient(#FF0000 0% ${currentValue}%, #333 ${currentValue}% 100%)`,
        'important'
      );

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    }

    requestAnimationFrame(update);
  }
});

/* Mobile ingredient section - add spacing between product image and card */
document.addEventListener('DOMContentLoaded', function() {
  // Only run on mobile
  if (window.innerWidth > 767) return;

  // Find the mobile ingredient section image
  const mobSection = document.querySelector('.mob-line-dot');
  if (!mobSection) return;

  const productImage = mobSection.querySelector('img.pf-449_');
  if (productImage) {
    // Add margin below the image to create space before the card
    productImage.style.setProperty('margin-bottom', '60px', 'important');
  }
});

/* Cart drawer discount code form */
if (!customElements.get('cart-discount-form')) {
  customElements.define('cart-discount-form', class extends HTMLElement {
    connectedCallback() {
      // Applied-code chips also render in the totals block outside this element,
      // so chip lookups are scoped to the whole drawer.
      this._root = this.closest('cart-drawer') || this;
      this._form = this.querySelector('form');
      this._input = this.querySelector('input[name="discount"]');
      this._submitButton = this._form.querySelector('button[type="submit"]');
      this._error = this.querySelector('.cart-discount__error');

      this._form.addEventListener('submit', (event) => this._onSubmit(event));
      this._root.querySelectorAll('[data-remove-discount]').forEach((button) => {
        button.addEventListener('click', () => this._onRemove(button.closest('[data-discount-code]').dataset.discountCode));
      });
    }

    get _appliedCodes() {
      return Array.from(this._root.querySelectorAll('[data-discount-code]')).map((el) => el.dataset.discountCode);
    }

    async _onSubmit(event) {
      event.preventDefault();
      const code = this._input.value.trim();
      if (code === '') return;

      this._error.hidden = true;
      const previousCodes = this._appliedCodes;

      if (previousCodes.some((applied) => applied.toLowerCase() === code.toLowerCase())) {
        this._input.value = '';
        return;
      }

      this._setLoading(true);

      try {
        const cart = await this._updateDiscounts(previousCodes.concat(code));

        // Cart JSON exposes discount_codes with an "applicable" flag; if the
        // field is missing we refresh optimistically and let the re-render decide.
        let applied = true;
        if (Array.isArray(cart.discount_codes)) {
          const entry = cart.discount_codes.find((d) => (d.code || '').toLowerCase() === code.toLowerCase());
          applied = Boolean(entry) && entry.applicable !== false;
        }

        if (applied) {
          this._refreshCart();
        } else {
          await this._updateDiscounts(previousCodes);
          this._error.hidden = false;
          this._setLoading(false);
        }
      } catch (error) {
        this._error.hidden = false;
        this._setLoading(false);
      }
    }

    async _onRemove(code) {
      this._setLoading(true);

      try {
        await this._updateDiscounts(this._appliedCodes.filter((applied) => applied !== code));
        this._refreshCart();
      } catch (error) {
        this._setLoading(false);
      }
    }

    async _updateDiscounts(codes) {
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      });

      if (!response.ok) {
        throw new Error('Could not update cart discounts');
      }

      return response.json();
    }

    _refreshCart() {
      // The drawer re-fetches its section HTML and replaces this element,
      // so there is no need to reset the loading state on success.
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }

    _setLoading(isLoading) {
      this._submitButton.toggleAttribute('disabled', isLoading);
      this._submitButton.setAttribute('aria-busy', isLoading);
    }
  });
}

/* ── Floating-widget / sticky-ATC conflict manager ──────────────────────────
   On the PageFly product pages the sticky add-to-cart bar (z 9999), the Crisp
   chat launcher (z ~1,000,002) and the language switcher (z 9999) all live at
   the bottom of the viewport. Two problems:
     1) When the Judge.me write-review modal (z 1100) opens, all three cover its
        buttons. Fix: hide them while the modal is open (CSS .bf-modal-open).
     2) On mobile the widgets stack on top of the sticky bar. Fix: lift them
        above it while the bar is visible (CSS .bf-sticky-atc).                */
(function () {
  var html = document.documentElement;

  // 1) Judge.me review modal open-state. Judge.me injects its modal into the
  //    DOM asynchronously (often only after its widget loads), so we watch the
  //    document for the modal appearing, then observe its display/class for the
  //    open toggle.
  var modalSelector = '.jdgm-write-review-modal, .jdgm-review-widget-modal';
  var syncModal = function () {
    var open = false;
    document.querySelectorAll(modalSelector).forEach(function (m) {
      if (getComputedStyle(m).display !== 'none') open = true;
    });
    html.classList.toggle('bf-modal-open', open);
  };
  var modalObserver = new MutationObserver(syncModal);
  var attachModalObservers = function () {
    document.querySelectorAll(modalSelector).forEach(function (m) {
      if (!m.dataset.bfObserved) {
        m.dataset.bfObserved = '1';
        modalObserver.observe(m, { attributes: true, attributeFilter: ['style', 'class'] });
      }
    });
  };
  attachModalObservers();
  syncModal();
  // Catch the late-injected modal (and any re-injection).
  new MutationObserver(function () {
    attachModalObservers();
    syncModal();
  }).observe(document.body, { childList: true, subtree: true });

  // 2) Sticky ATC bar visibility
  var stickyBtn = document.querySelector('.sticky-atc-btn');
  if (stickyBtn) {
    var stickyWrap = stickyBtn;
    while (stickyWrap && getComputedStyle(stickyWrap).position !== 'fixed') {
      stickyWrap = stickyWrap.parentElement;
    }
    if (stickyWrap) {
      var ticking = false;
      var syncSticky = function () {
        ticking = false;
        var cs = getComputedStyle(stickyWrap);
        var r = stickyWrap.getBoundingClientRect();
        var visible = cs.display !== 'none' && cs.visibility !== 'hidden' &&
          parseFloat(cs.opacity) > 0.1 && r.height > 0 &&
          r.top < window.innerHeight && r.bottom > 0;
        html.classList.toggle('bf-sticky-atc', visible);
      };
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(syncSticky);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      syncSticky();
    }
  }
})();
